import { BranchDetail } from '@/types/branch'
import { api } from '@/utils/api'
import { apiBranchesSlug } from '@/utils/api/url'
import { createRouteForAPI } from '@/utils/helpers/urlHelper'

import { useQuery } from '@tanstack/react-query'

export const QUERY_KEY_BRANCH_DETAIL = 'QUERY_KEY_BRANCH_DETAIL'

export const useGetBranchDetail = ({ branch }: { branch: string }) => {
  const query = useQuery({
    queryKey: [QUERY_KEY_BRANCH_DETAIL, branch],
    staleTime: 60 * (60 * 1000), // 60mins
    queryFn: () =>
      api
        .get(createRouteForAPI(apiBranchesSlug, { branch }))
        .then(({ data }) => data as BranchDetail),
    enabled: !!branch,
  })

  return query
}
